import iIcon from "../../shared/assets/img/iIcon.svg";
import ollieSmile01 from "../../shared/assets/img/ollie/ollie-smile-01.svg";

type OllieProps = {
    type?: "smile" | "happy" | "content" | "excited" | "proud" | "sad" | "slightlySad" | "anxious" | "mad" | "openmouth";
    variant?: "01" | "02" | "03" | "04" | "05";
    size?: "xsmall" | "small" | "medium" | "large";
    infoText?: string;
    onInfoClick?: () => void;
};

export const Ollie = (props: OllieProps) => {

    const getSizeClasses = () => {
        switch (props.size) {
            case "xsmall":
                return "w-12 h-12"; // 48px
            case "small":
                return "w-24 h-24"; // 96px
            case "large":
                return "w-[164px] h-[164px]"; // 164px
            case "medium":
            default:
                return "w-32 h-32"; // 128px (default)
        }
    };

    return (
        <div className="relative flex justify-center" onClick={props.onInfoClick}>
            <img src={ollieSmile01} alt="ollie" className={getSizeClasses()} />

            {props.infoText && (
                <div className={`absolute top-10 left-1/2 transform translate-x-8 flex items-center gap-1 max-w-[200px] ${props.type === "anxious" ? '-translate-x-full! top-1!' : ''}`} onClick={props.onInfoClick}>
                    <img src={iIcon} alt="info" />
                    <p className="text-osGrey-2 text-xs">{props.infoText}</p>
                </div>
            )}
        </div>
    );
}; 